import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { ApplicationRoutes } from '../../../utils/routes';
import { useLocation } from 'react-router-dom';

const menuItems = [
  {
    name: 'Personalise',
    route: ApplicationRoutes.CreateAccount,
  },
  {
    name: 'Signers',
    route: ApplicationRoutes.SignersForm,
  },
  {
    name: 'Set Threshold',
    route: ApplicationRoutes.ThresholdForm,
  },
  {
    name: 'Summary',
    route: ApplicationRoutes.SummaryForm,
  },
];

const CheckIcon = (props: any) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
    />
  </Icon>
);

const Menu = () => {
  const location = useLocation();

  const currentIndex = menuItems.findIndex(
    (item) => item.route === location.pathname,
  );

  return (
    <Flex
      w={318}
      h="100%"
      p={14}
      gap={14}
      borderRadius={16}
      textAlign="center"
      direction="column"
      background="white"
      boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)"
    >
      <Text size="lg" variant="bodyBold">
        Create Account
      </Text>
      <Box display="flex" flexDirection="column" alignItems="flex-start" gap={5}>
        {menuItems.map((menuItem, index) => {
          const isCurrent = index === currentIndex;
          const isCompleted = index < currentIndex;

          return (
            <Flex key={menuItem.name} alignItems="center" gap={3}>
              <Flex
                w="28px"
                h="28px"
                borderRadius="full"
                alignItems="center"
                justifyContent="center"
                flexShrink={0}
                bg={isCompleted ? '#B7F133' : isCurrent ? 'blackAlpha.900' : 'blackAlpha.100'}
                color={isCompleted ? 'blackAlpha.900' : isCurrent ? 'white' : 'blackAlpha.500'}
                fontSize="xs"
                fontWeight={700}
                transition="all 0.3s ease"
              >
                {isCompleted ? (
                  <CheckIcon boxSize="14px" />
                ) : (
                  index + 1
                )}
              </Flex>
              <Text
                size="md"
                variant={isCurrent ? 'bodyBold' : isCompleted ? 'bodyBold' : 'semiBold'}
                color={isCurrent ? 'black' : isCompleted ? 'blackAlpha.700' : 'blackAlpha.500'}
                transition="all 0.3s ease"
              >
                {menuItem.name}
              </Text>
            </Flex>
          );
        })}
      </Box>
    </Flex>
  );
};

export default Menu;
